import { Middleware } from '@nuxt/types';

const navigation: Middleware = async (context) => {
  const { app, route, store } = context;

  if (process.client) {
    return;
  }

  let pageConfig: Record<string, any> | boolean = false;

  for (const [routeName, config] of Object.entries(app.$channelConfig('page'))) {
    if (routeName === route.name) {
      pageConfig = config;
    }
  }

  if (pageConfig) {
    const data = pageConfig.component?.header?.navigation?.bottom;
    if (data) {
      store.commit('navigation/setHeaderBottomNavigation', { navigation: data, overwrite: !!data });
    }
  }
};

export default navigation;
